<template>
  <div class="content freelist" v-loading="pageLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">评级模型名称</div>
          <el-input
            size="mini"
            v-model="modelName"
            placeholder="请输入"
            class="ipt-sty"
          />
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">启用状态</div>
          <el-select
            size="mini"
            v-model="bizState"
            placeholder="请选择"
            class="ipt-sty"
          >
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch"
            >清空</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" >
      <div class="button-area">
        <el-button size="mini" type="info" @click="addFieldConfig"
          >添加评级模型</el-button
        >
      </div>
      <el-table
        :data="tableData"
        stripe
        border
        :height="tableHeight"
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          label="序号"
          header-align="center"
          align="center"
          fixed="left"
          width="60"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="tenantName"
          label="评级模型名称"
          header-align="center"
          align="left"
          min-width="160"
        >
          <template slot-scope="scope">{{ scope.row.modelName }}</template>
        </el-table-column>
        <el-table-column
          prop="abbreviation"
          label="启用状态"
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{
            scope.row.bizState | bizStateFilter
          }}</template>
        </el-table-column>
        <el-table-column
          prop="gradeCycle"
          label="评级周期"
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{
            scope.row.gradeCycle | gradeCycleFilter
          }}</template>
        </el-table-column>

        <el-table-column
          prop=" tenantNote"
          label="应用公司"
          header-align="center"
          align="left"
          width="150"
        >
          
          <template slot-scope="scope">
            <span v-if="scope.row.tenantNameList&&scope.row.tenantNameList.length>1&&scope.row.tenantNameList.length<=6">
              <el-popover
              placement="top-start"
              width="350"
              trigger="hover"
              :content="scope.row.tenantNameList.toString()">
              <span class="show-pop" slot="reference">查看</span>
            </el-popover>
            </span>
            <span v-else-if="scope.row.tenantNameList&&scope.row.tenantNameList.length>6">{{`应用公司${scope.row.tenantNameList.length}家` }}</span>
            <!-- <span v-if="scope.row.tenantNameList.length>1">查看</span> -->
            <span v-else-if="scope.row.tenantNameList&&scope.row.tenantNameList.length==1">{{scope.row.tenantNameList[0] }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="initUserName"
          label="应用部门"
          header-align="center"
          align="left"
          width="150"
        >
          <template slot-scope="scope">{{
            scope.row.organisationName || "-"
          }}</template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="创建时间"
          header-align="center"
          align="left"
          min-width="160"
        >
          <template slot-scope="scope">{{
            scope.row.createTime | getTimeDate
          }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          fixed="right"
          min-width="220"
        >
          <template slot-scope="scope">
            <a class="txt-color" @click="copyModel(scope.row)">复制｜</a>
            <a
              class="txt-color"
              @click="editFieldConfig(deepCopy(scope.row), scope.$index)"
              >编辑｜</a
            >
            <a class="txt-color" v-if="scope.row.bizState=='Y'"  @click="editState(scope.row,'N')">设为禁用｜</a>
            <a class="txt-color" v-else @click="editState(scope.row,'Y')">设为启用｜</a>
            <a class="txt-color-red" @click="delModel(scope.row.guid)"
              >删除
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <!-- //! 编辑弹框 -->
    <el-dialog
      :title="textTitle"
      top="5vh"
      custom-class="configure-fields"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="right" class="demo-ruleForm">
        <div class="title" style="padding-left: 20px">
          <span></span>模型信息
        </div>
        <el-row>
          <el-col :span="12">
            <!-- 评级模型名称 -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">评级模型名称： </span>
              <el-input
                class="fl w240"
                type="input"
                placeholder="请输入模型名称"
                v-model="configForm.modelName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 评级周期 -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">评级周期：</span>
              <el-select
                class="fl w240"
                filterable
                v-model="configForm.gradeCycle"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in gradeCycleList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <!-- 应用公司 -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">应用公司：</span>
              <el-select
                class="fl w240"
                filterable
                multiple
                collapse-tags
                v-model="configForm.tenantGuidList"
                placeholder="请选择"
                @change="selectCpy(configForm.tenantGuidList,2)"
              >
                <el-option
                  v-for="item in tenantList"
                  :key="item.guid"
                  :label="item.tenantName"
                  :value="item.guid"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 应用部门 -->
            <el-form-item>
              <span slot="label" style="color: red"> </span>
              <span slot="label">应用部门：</span>
              <el-select
                class="fl w240"
                filterable
                value-key="guid"
                v-model="configForm.organisationGuid"
                placeholder="请选择"
                @visible-change="showOrg"
                @change="selectOrg(configForm.organisationGuid)"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.guid"
                  :label="item.organisationName"
                  :value="item.guid"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item class="field-radio">
            <!-- <span slot="label" style="color: white">*</span> -->
            <span slot="label">模型描述：</span>
            <el-input
              style="width: 530px"
              type="textarea"
              :rows="3"
              maxlength="100"
              placeholder="仅可输入英文、中文、顿号"
              v-model="configForm.modelDesc"
              @input="
                configForm.modelDesc = configForm.modelDesc.replace(
                  /[^\a-\z\A-\Z\、\u4E00-\u9FA5]/g,
                  ''
                )
              "
            >
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <el-form label-width="120px" label-position="right" class="demo-ruleForm">
        <div style="display: flex; justify-content: space-between">
          <div class="title" style="padding-left: 20px">
            <span></span>指标信息
          </div>
        </div>
        <TabList
          :tabList="appsideList"
          :tabIndex="tabIndex"
          @tabChange="tabChange"
        ></TabList>
        <div v-if="!showGrade" >
          <el-button
          
          class="fr"
          size="mini"
          type="info"
          @click="addDetail"
        >
          {{ "添加指标" }}</el-button
        >
        <div style="clear: both;"></div>
        <el-table
         
          :data="configForm.indicateDetailJson"
          stripe
          class="detail-class"
          style="width: 90%; margin:auto"
        >
          <!-- 序号 -->
          <el-table-column
            prop="orderNum"
            label="序号"
            header-align="center"
            align="left"
            width="60"
            
          >
            <template slot-scope="scope">
              <el-input
              
                v-model="scope.row.orderNum"
                @input="scope.row.orderNum=scope.row.orderNum.replace(/[^0-9]/g,'')"
                size="mini"
              />
            </template>
          </el-table-column>
          <!-- 指标大类 -->
          <el-table-column
            prop="scoreContent"
            label="指标大类"
            
            header-align="left"
            align="left"
            
          >
            <template slot-scope="scope">
              <el-select
                size="mini"
                filterable
                v-model="scope.row.gradeCategoryGuid"
                placeholder="请选择"
                @focus="focusTag(scope.row,2)"
                @change="selectTag(scope.row,2)"
               
              >
                <el-option
                  v-for="item in tagList"
                  :key="item.guid"
                  :label="item.categoryName"
                  :value="item.guid"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <!-- 大类权重 -->
          <el-table-column
            prop="score"
            label="大类权重(%)"
            header-align="left"
            align="left"
            width="100"
          >
            <template slot-scope="scope">
              <el-input
                v-show="scope.row.showWeight"
                v-model="scope.row.categoryWeight"
                size="mini"
                class="w60"
                @input="scope.row.categoryWeight=scope.row.categoryWeight.replace(/[^0-9]/g,'')"
              />
            </template>
          </el-table-column>
          <!-- 指标名称 -->
          <el-table-column
            prop="indicateName"
            label="指标名称"
            header-align="left"
            align="left"
            
          >
            <template slot-scope="scope">
              <el-select
              size="mini"
                class="fl"
                v-model="scope.row.indicateGuid"
                placeholder="请选择"
                @change="selectCtg(scope.row)"
              >
                <el-option
                  v-for="item in scope.row.categoryList"
                  :key="item.guid"
                  :label="item.indicateName"
                  :value="item.guid"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <!-- 指标权重 -->
          <el-table-column
            prop="score"
            label="指标权重(%)"
            header-align="left"
            align="left"
            width="100"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.indicateWeight"
                size="mini"
                @input="scope.row.indicateWeight=scope.row.indicateWeight.replace(/[^0-9]/g,'')"
              />
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            label="操作"
            header-align="right"
            align="right"
            width="80"
          >
            <template slot-scope="scope">
              <a
                style="padding-left: 5px"
                class="txt-color"
                @click="delDetail(scope.$index,1)"
              >
                删除
              </a>
            </template>
          </el-table-column>
        </el-table>
        <p  class="tips-class">
            备注：指标大类权重相加必须为100，指标大类下的指标权重相加必须为100。
          </p>
        </div>
        <div v-else style="overflow: hidden;">
          <el-button
            class="fr"
            size="mini"
            type="info"
            @click="addGrade"
          >
            {{ "添加等级" }}</el-button
          >
          <div style="clear: both;"></div>
          <el-table
            :data="configForm.levelDetailJson"
            stripe
            class="detail-class"
            style="width: 90%; margin:auto;"
          >
            <!-- 序号 -->
            <el-table-column
              prop="orderNum"
              label="序号"
              header-align="center"
              align="left"
              width="60"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.orderNum"
                  size="mini"
                  @input="scope.row.orderNum=scope.row.orderNum.replace(/[^0-9]/g,'')"
                />
              </template>
            </el-table-column>
            <!-- 区间最小值(包含) -->
            <el-table-column
              prop="scoreContent"
              
              label="区间最小值(包含)"
              header-align="left"
              align="left"
            >
              <template slot-scope="scope">
                <el-input
                  class="w120"
                  v-model="scope.row.minValue"
                  size="mini"
                  @input="scope.row.minValue=scope.row.minValue.replace(/[^0-9]/g,'')"
                />
              </template>
            </el-table-column>
            <!-- 区间最大值(包含) -->
            <el-table-column
              prop="scoreContent"
              label="区间最大值(不包含)"
              header-align="left"
              align="left"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.maxValue"
                  size="mini"
                  class="w120"
                  @input="scope.row.maxValue=scope.row.maxValue.replace(/[^0-9]/g,'')"
                />
              </template>
            </el-table-column>
            <!-- 等级 -->
            <el-table-column prop="score" label="等级" header-align="left" align="left" width="80">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.grade"
                    size="mini"
                    class="w60"
                    maxlength="1"
                  />
                </template>
              </el-table-column>
              
            <el-table-column
              label="操作"
              header-align="left"
              align="left"
              width="80"
            >
              <template slot-scope="scope">
                <a
                  style="padding-left: 5px"
                  class="txt-color"
                  @click="delDetail(scope.$index,2)"
                >
                  删除
                </a>
              </template>
            </el-table-column>
          </el-table>
          <p  class="tips-class">
            备注：小于10，则在区间最大值写10，最小值不用写；[10,50)则在最小值写10，最大值写50；大于等于90，则在最小值写90，最大值不写。
          </p>
        </div>
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="visible = false">取 消</el-button>
        <el-button size="mini" type="info" v-if="isEdit" @click="addModel(1)">修 改</el-button>
        <el-button size="mini" type="info" v-else @click="addModel(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { route } from "@/api/apiRoute";
  import store from "@/store";
  import TabList from "@/components/tab/tabList.vue";
  export default {
    components: {
      TabList,
    },
    data() {
      return {
        tableHeight: window.innerHeight - 280,
        pageLoading:false,
        loading: false,
        visible: false,
        isEdit: false,
        textTitle: "",
        showGrade: false,
        checkAll:false,
        page: {
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
        },
        modelName: "",
        bizState: "",
        modelGuid:"",
        oldGuid:'',
        tableData: [],
        promiseArr:[],
        configForm: {
          modelName: "", //模型名称
          gradeCycle: "", //评级周期
          bizState: "", //启用状态
          tenant:{},
          tenantName: "", //应用公司
          tenantGuid: "", //应用公司id
          tenantGuidList:[],//应用公司id
          // organisation:{},
          organisationName: "", //应用部门
          organisationGuid: "", //应用部门id
          modelDesc: "", //模型描述
          indicateDetailJson: [], //评级模型指标设置明细
          levelDetailJson: [], //评级模型等级设置明细
        },
        // 应用公司列表
        tenantList: [],
        tenantGuidList: [],
        // 应用部门列表
        departmentList: [],
        //
        tagList: [], //标签指标大类
        // categoryList: [], //评级指标

        // 评级周期列表
        gradeCycleList: [
          {
            value: "D",
            label: "日",
          },
          {
            value: "W",
            label: "周",
          },
          {
            value: "M",
            label: "月",
          },
          {
            value: "S",
            label: "季",
          },
          {
            value: "H",
            label: "半年",
          },
          {
            value: "Y",
            label: "年",
          },
          {
            value: "0",
            label: "一次性",
          },
        ],
        // 状态
        status: [
          {
            value: "Y",
            label: "启用",
          },
          {
            value: "N",
            label: "禁用",
          },
        ],
        appsideList: [
          {
            tabName: "指标设置",
          },
          {
            tabName: "等级设置",
          },
        ],
        tabIndex: 0,
      };
    },
    filters: {
      bizStateFilter(val) {
        if (!val) return "-";
        if (val == "Y") {
          return "启用";
        } else if (val == "N") {
          return "禁用";
        }
      },
      gradeCycleFilter(val) {
        if (!val) return "-";
        if (val == "D") {
          return "日";
        } else if (val == "W") {
          return "周";
        } else if (val == "M") {
          return "月";
        }else if (val == "S") {
          return "季";
        }else if (val == "H") {
          return "半年";
        } else if (val == "Y") {
          return "年";
        } else if (val == "0") {
          return "一次性";
        }
      },
    },
    created() {
      // this.getList();
    },
    mounted() {
      this.search();
    },
    watch: {
      
    },
    methods: {
      // 获取评级模型
      search() {
        let that = this;
        that.loading = true;
        that.tableData = [];
        let req = {
          pageIndex: that.page.pageIndex,
          pageSize: that.page.pageSize,
          modelName: that.modelName || "",
          bizState: that.bizState || "",
        };
        that.api
          .postJson(
            `/${serverConfig.msCustomerService}/data-grade/model/page-list`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tableData = res.data.data.records;
              that.page.totalPage = res.data.data.totalPages;
              that.page.totalRows = res.data.data.totalRows;
              that.loading = false;
              // console.log("that.tableData", that.tableData);
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 获取应用公司
      getCompany() {
        let that = this;
        let query ={
          enterpriseCates: ["0101", "010201"],
          pageIndex:1,
          pageSize:-1
        }
        that.tenantGuidList=[]
        that.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tenantList = res.data.data.records;
              res.data.data.records.forEach(item=>{
                that.tenantGuidList.push(item.guid
                )
              })
              let row={
                guid:'1',
                tenantName:'全部'
              }
              that.tenantList.unshift(row)
              // console.log('that.tenantList',that.tenantList)
              // 增加全选
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 选择应用公司获取应用部门
      selectCpy(val,flg) {
        // flg=2为选中事件
        let that = this;
        
        that.departmentList = [];
        if(flg==2){
          that.configForm.organisationGuid = '';
          let index=val.findIndex(item=>{
            return item=='1'
          })
          if(index!=-1){
            // 说明选中了全部
            that.checkAll=true
            that.configForm.tenantGuidList=['1']
            return 
          }else{
            that.checkAll=false
          }
          
        }else{
          // flag==1从编辑或者复制进入
          that.promiseArr=[]


        }
        // console.log('that.checkAll',that.checkAll);
        // if(val.length==1){
        //   let company=[]
        // company =that.tenantList.filter(item=>{
        //   return val[0]==item.sendTenantGuid
        // })
        // if(company.length>0){
        //   that.configForm.tenantName=company[0].sendTenantName
        // }
        // }
        
        if(val.length!=1)return
        let req = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: val[0],//公司唯一标识
          sendTenantGuid: localStorage.guid,
        };
        that.api
          .postJson(
            `/${serverConfig.msPersonnelService}/organisation/data/get`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.departmentList = res.data.data.records;
              that.$forceUpdate();
              // console.log('22',that.configForm);
              // if(flg==1 && that.configForm.indicateDetailJson){
              
              // that.configForm.indicateDetailJson.forEach(item=>{
              //   // item.categoryList=[]
              //   that.promiseArr.push(that.selectTag(item,1))
                
              //   // that.visible = true;
              // })
              // }else{
              //   that.visible=true
              // }
              // Promise.all(that.promiseArr).then(
              //   that.visible=true)
              // .catch(e => console.log(e));

            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 选择应用部门
      selectOrg(val) {
        let that=this
        let indicate =that.departmentList.filter(item=>{
          return val==item.guid
        })
        that.configForm.organisationName=indicate[0].organisationName
        
        
        this.$forceUpdate();
      },
      showOrg(val){
        if(val&&this.configForm.tenantGuidList.length<1){
          this.$message.error('请先选择应用公司')
        }
        if(val&&this.checkAll){
          this.$message.error('无需选择应用部门')
        }
        if(val&&this.configForm.tenantGuidList.length>1){
          this.$message.error('无需选择应用部门')
        }
      },
      // 选择指标名称
      selectCtg(row) {
        let indicate =row.categoryList.filter(item=>{
          return row.indicateGuid==item.guid
        })
        row.indicateName=indicate[0].indicateName
        // console.log('22',row.indicateName);
        
        this.$forceUpdate();
      },

      // 获取标签指标大类
      getTagList(name) {
        let that = this;
        let req = {
          pageIndex: 1,
          pageSize: -1,
        };
        that.api
          .postJson(
            `/${serverConfig.msCustomerService}/data-grade/category/page-list`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tagList = res.data.data.records;
              // console.log("that.tagList", that.tagList);
              // // 默认选中第一个标签
              // this.$refs.singleTable.setCurrentRow(that.tagList[0]);
              // this.gradeCategoryGuid = that.tagList[0].guid;
              // this.search();
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 获取焦点的时候存旧值
      focusTag(row){
        if(row.showWeight){
          this.oldGuid=row.gradeCategoryGuid
        }else{
          this.oldGuid=''
        }
      },
      filterFn(guid){
        let that=this
        let filterList= that.configForm.indicateDetailJson.filter((item,index)=>{
          if(guid==item.gradeCategoryGuid){
            item.index=index
          }
          return guid==item.gradeCategoryGuid
          
        })
        if(filterList.length>0){
          let idx=filterList[0].index
          filterList.forEach((item,index)=>{
            that.configForm.indicateDetailJson[item.index].showWeight=false
          })
          
          that.configForm.indicateDetailJson[idx].showWeight=true

        }
        console.log('fff',filterList);
        
      },
      // 选择指标大类,获取评级指标
      selectTag(row,flg) {
        // flg=2为选中事件
        let that = this;
        this.filterFn(row.gradeCategoryGuid)
        if(this.oldGuid){
          this.filterFn(this.oldGuid)
        }
        // let index=that.configForm.indicateDetailJson.findIndex((item,index)=>{
        //   return row.gradeCategoryGuid==item.gradeCategoryGuid
          
        // })
        // if(index>-1){
        //   that.configForm.indicateDetailJson[index].showWeight=true
        // }
        console.log('ind',that.configForm.indicateDetailJson);
        
        // row.categoryList=[]
        // that.$forceUpdate(); 
        let category=[]
        category =that.tagList.filter(item=>{
          return row.gradeCategoryGuid==item.guid
        })
        // console.log('val3',category);
        if(category.length>0){
          row.categoryName=category[0].categoryName
        }
        
        // console.log('val123',category,row.gradeCategoryGuid,row.categoryName);
        if(flg==2){
          row.indicateGuid=""
          // row.indicateName=""
        }else{
          
          if(!row.gradeCategoryGuid){
            // that.visible=true
            return
          }
        }
       
        let req = {
          pageIndex: 1,
          pageSize: -1,
          // tenantGuid: localStorage.guid,
          gradeCategoryGuid: row.gradeCategoryGuid, //标签的guid
          bizState:'Y'
        };
        // console.log('req',req);
        
        that.api
          .postJson(
            `/${serverConfig.msCustomerService}/data-grade/indicate/page-list`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // row.categoryList = res.data.data.records;
              that.$nextTick(()=>{
                that.$set(row,'categoryList',res.data.data.records)
                that.visible=true
              that.$forceUpdate(); 

              })
              
              // if(flg==1){
              //   that.visible = true;
              // }
              
              
              // console.log("categoryList", row.categoryList,category);
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 删除打分信息
      delDetail(index,flg) {
        let that = this;
        that
          .$confirm("删除后不可恢复，确定删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            
            if(flg==1){
              // 删除指标
              if(this.configForm.indicateDetailJson[index].showWeight) {
                if(this.configForm.indicateDetailJson[1+index]){
                  this.configForm.indicateDetailJson[1+index].showWeight=true
                  this.configForm.indicateDetailJson[1+index].categoryWeight=this.configForm.indicateDetailJson[index].categoryWeight
                }
               
              }
              
              console.log('lll',this.configForm.indicateDetailJson);
              
              this.configForm.indicateDetailJson.splice(index, 1);
            }else if(flg==2){
              // 删除等级
              this.configForm.levelDetailJson.splice(index, 1);
            }
            
          });
      },
      deepCopy(val) {
        return JSON.parse(JSON.stringify(val));
      },
      // 点击tab
      tabChange(item, index) {
        // console.log("index", index);
        // this.tabIndex = index;
        this.showGrade = index == 1 ? true : false;
      },
      // 清空搜索
      emptySearch() {
        this.modelName = "";//模型名称
        this.bizState = "";
        this.search();
      },

      // 添加评级模型按钮弹窗
      addFieldConfig() {
        // this.tabIndex = 0;
        // this.$forceUpdate();
        this.visible = true;
        // this.currentIndex = '';
        this.isEdit = false;
        this.textTitle = "添加评级模型";
        this.configForm={
          modelName: "", //模型名称
          gradeCycle: "", //评级周期
          tenantName: "", //应用公司
          tenantGuid: "", //应用公司id
          tenantGuidList: [], //应用公司id
          organisationName:'',
          organisationGuid:'',
          modelDesc: "", //模型描述
          indicateDetailJson: [], //评级模型指标设置明细
          levelDetailJson: [], //评级模型等级设置明细
        };
        this.getTagList(); //获取指标大类
        this.getCompany();//获取应用公司
      },
      // 编辑评级模型按钮弹窗
      editFieldConfig(detail) {
        // console.log(detail);
        // 先请求评级指标详情
        let that = this;

        that.modelGuid = detail.guid;
        this.getTagList(); //获取指标大类
        this.getCompany();//获取应用公司
        that.api
          .get(
            `/${serverConfig.msCustomerService}/data-grade/model/detail/${that.modelGuid}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.configForm = res.data.data;
              if(that.configForm.applyAll=='Y'){
                that.configForm.tenantGuidList=['1']
                that.checkAll=true
              }else if(that.configForm.tenantGuid&&!that.configForm.tenantGuidList){
                that.configForm.tenantGuidList=[]
                that.configForm.tenantGuidList.push(that.configForm.tenantGuid)
                that.selectCpy(that.configForm.tenantGuidList,1)
              } else if(that.configForm.tenantGuidList&&that.configForm.tenantGuidList.length==1) {
                that.selectCpy(that.configForm.tenantGuidList,1)
              }else{
                that.visible=true
              }
              if( that.configForm.indicateDetailJson){
              
              that.configForm.indicateDetailJson.forEach(item=>{
                // item.categoryList=[]
                that.promiseArr.push(that.selectTag(item,1))
                
                // that.visible = true;
              })
              }else{
                that.visible=true
              }
              Promise.all(that.promiseArr).then(
                that.visible=true)
              .catch(e => console.log(e));
              // if(that.configForm.indicateDetailJson&&that.configForm.indicateDetailJson.length>0){
              //   that.configForm.indicateDetailJson.forEach(item=>{
              //     that.selectTag(item,1)
              //   })
              // }
              that.isEdit = true;
              that.textTitle = "编辑评级模型";
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 数组去重
      unipFunc(arr) {
        let arr1 = []; //存id
        let newArr = []; //存新数组
        for(let i in arr){
          if(arr1.indexOf(arr[i].gradeCategoryGuid) == -1){
            arr1.push(arr[i].gradeCategoryGuid);
            newArr.push(arr[i]);
          }
        }
        return newArr;
    },
      mapFunc(arr1,arr2){
        let newArr=[]
        arr1.forEach((item,idx)=>{
          newArr[idx]=[]
          for(let i in arr2){
            if(item.gradeCategoryGuid==arr2[i].gradeCategoryGuid){
              newArr[idx].push(arr2[i])
              // console.log('aaa',newArr);
              
            }
          }
        })
        // let arr=newArr.reduce(function (a, b) { 
        //   return a.concat(b)
        // })
        return newArr
      },
      // 新增、修改模型
      addModel(flg){
        // flg=1修改flg=2新增
        let that=this
        // if (!this.configForm.modelName) {
        //   this.$message.error('请填写评级模型名称');
        //   return;
        // } 
        if (!this.configForm.gradeCycle) {
          this.$message.error('请选择评级周期');
          return;
        } 
        if (!this.configForm.tenantGuidList||this.configForm.tenantGuidList.length<1) {
          this.$message.error('请选择应用公司');
          return;
        } 
        if(that.configForm.indicateDetailJson&&that.configForm.indicateDetailJson.length>0){
          let weight=that.configForm.indicateDetailJson.reduce((p,c)=>{
            return p + Number(c.categoryWeight) 
          },0)
          // console.log('weight',weight);
          
          if (weight!=100) {
            this.$message.error('请将设置的指标大类权重和为100');
            return;
          } 
          let newArr=that.unipFunc(that.configForm.indicateDetailJson)
          // console.log('newArr',newArr);
          let newArr2=that.mapFunc(newArr,that.configForm.indicateDetailJson)
          // console.log('newArr2',newArr2);
          let showMes=false
          newArr2.forEach(item=>{
            
            let a=item.reduce((p,c)=>{
              return p + Number(c.indicateWeight) 
            },0)
            if(a!=100)showMes=true
          })
          if(showMes){
            this.$message.error('请将设置的指标权重和为100');
            return;
          }
        }
        
        
          
        // flg=1修改flg=2新增
        if(flg==1){
          let req={
            guid:that.modelGuid,
            ...that.configForm,
            applyAll:that.checkAll?'Y':'N',
            tenantGuidList:that.checkAll?that.tenantGuidList:that.configForm.tenantGuidList
          }
          that.api
          .put(
            `/${serverConfig.msCustomerService}/data-grade/model/update`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.$message.success('修改成功！');
              that.visible=false
              that.search()
            } else {
              that.$message.error(res.data.msg);
            }
          });
        }else{
          
          let req={
            ...that.configForm,
            applyAll:that.checkAll?'Y':'N',
            tenantGuidList:that.checkAll?that.tenantGuidList:that.configForm.tenantGuidList
          }
          that.api
          .postJson(
            `/${serverConfig.msCustomerService}/data-grade/model/add`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.$message.success('保存成功！');
              that.visible=false
              that.search()
            } else {
              that.$message.error(res.data.msg);
            }
          });
        }
        
      },
     
      // 复制模型
      copyModel(detail) {
        // console.log(detail);
        // 先请求评级指标详情
        let that = this;

        let guid = detail.guid;
        this.getTagList(); //获取指标大类
        this.getCompany();//获取应用公司
        that.api
          .get(
            `/${serverConfig.msCustomerService}/data-grade/model/detail/${guid}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.configForm = res.data.data;
              that.configForm.modelName=''
              if(that.configForm.applyAll=='Y'){
                that.configForm.tenantGuidList=['1']
                that.checkAll=true
              }else if(that.configForm.tenantGuidList&&that.configForm.tenantGuidList.length==1) {
                that.selectCpy(that.configForm.tenantGuidList,1)
              }else{
                that.visible=true
              }
              if( that.configForm.indicateDetailJson){
              
              that.configForm.indicateDetailJson.forEach(item=>{
                // item.categoryList=[]
                that.promiseArr.push(that.selectTag(item,1))
                
                // that.visible = true;
              })
              }else{
                that.visible=true
              }
              Promise.all(that.promiseArr).then(
                that.visible=true)
              .catch(e => console.log(e));
              // if(that.configForm.indicateDetailJson&&that.configForm.indicateDetailJson.length>0){
              //   that.configForm.indicateDetailJson.forEach(item=>{
              //     that.selectTag(item,1)
              //   })
              // }
              
              // if(that.configForm.tenantGuid){
              //   that.selectCpy(that.configForm.tenantGuid,1)
              // }else if(that.configForm.indicateDetailJson.length>0){
              //   that.configForm.indicateDetailJson.forEach(item=>{
              //     that.selectTag(item,1)
              //   })
              // } else{
              //   that.visible=true
              // }
              
              
              that.isEdit = false;
              that.textTitle = "添加评级模型";
            } else {
              that.$message.error(res.data.msg);
            }
          });

         
            
        
      },
      // 删除模型
      delModel(guid) {
        var that = this;
        that
          .$confirm("删除后不可恢复，确定删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            that.api.postJson(`/${serverConfig.msCustomerService}/data-grade/model/del`,[guid]).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  
                  that.$message.success('删除成功');
                  
                  that.search()
                } else {
                  that.$message.error(res.data.msg);
                }
              });
          });
      },
      // 修改启用状态
      editState(row,val){
        let that=this
        that.pageLoading=true
        let req={
          guid: row.guid,
          bizState:val,
          serviceTenantGuid:localStorage.guid
        }
        that.api
          .put(
            `/${serverConfig.msCustomerService}/data-grade/model/update-state`,
            req
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.$message.success('修改成功！');
              that.pageLoading=false
              that.search()
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      // 添加打分标准
      addDetail(guid) {
        if(!this.configForm.indicateDetailJson){
          this.configForm.indicateDetailJson=[]
        }
        let num=this.configForm.indicateDetailJson.length +1
        let detail = {
          orderNum: num, //排序号
          gradeCategoryGuid: "", //指标大类id
          categoryName: "", //指标大类
          indicateName: "", //指标名称
          indicateGuid:''	,//指标id
          categoryWeight: "", //指标大类权重
          indicateWeight: "", //指标权重
          categoryList:[],
          showWeight:false
        };
        
        this.configForm.indicateDetailJson.push(detail);
        
        
        
      },
      // 添加等级
      addGrade(guid) {
        if(!this.configForm.levelDetailJson){
          this.configForm.levelDetailJson=[]
        }
        let num=this.configForm.levelDetailJson.length +1
        let detail = {
          orderNum: num, //排序号
          minValue: null,//最大值
          maxValue: null,//最小值
          grade: "",//等级
        };
        
        this.configForm.levelDetailJson.push(detail);
        
      },
      // 分页
      handleSizeChange(val) {
        let that = this;
        that.page.pageSize = val;
        this.search();
      },
      handleCurrentChange(val) {
        let that = this;
        that.page.pageIndex = val;
        this.search();
      },
    },
  };
</script>
<style lang="less" scoped>
.show-pop{
  color: #4fa1a4;
}
.tips-class{
  width: 90%;
  margin: auto;
  color: #4fa1a4;
  text-align: left;
  font-size: 12px;
}
  .el-table /deep/ .el-input__inner {
    height: 30px;
    line-height: 40px;
  }

  .el-range-editor.el-input__inner {
    padding: 0px;
  }

  /deep/ .el-checkbox__label {
    display: none;
  }

  /deep/ .configure-fields {
    width: 800px !important;
  }
  /deep/ .configure-fields .el-dialog__body {
    overflow-y: auto;
    max-height: 600px;
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  .field-radio {
  display: flex;
  align-items: center;
}

.field-radio /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
/deep/ .el-form-item {
  margin-bottom: 8px;
}
 /* 选项内容样式 */
 /deep/ .select-content-box {
    width: 92%;
    margin: 0 0px 10px 30px;
  }
  /deep/ .select-content {
    width: 100%;
    /* padding:0 10px; */
    background: #fafafa;
    border: 1px solid #e5e5e5;
  }
  .attach-sty {
    width: 170px;
    float: left;
    margin-top: 15px;
    text-align: center;
  }

  .checkbox-img-sty {
    border: 1px solid #dcdfe6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
  }

  /deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color: #4fa1a4;
    border-color: inherit;
  }

  /deep/ .el-step__icon-inner {
    color: #4fa1a4;
  }

  /deep/ .el-step__title.is-process {
    color: #4fa1a4;
  }

  // .content {
  //   background: #fff;
  //   font-size: 18px;
  // }

  .title {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .title span {
    width: 6px;
    height: 14px;
    background: #4fa1a4;
    display: inline-block;
    margin-right: 10px;
  }

  .base {
    background: #fff;
    padding: 10px 0;
  }

  .content h1 {
    margin: 4px 0px;
  }

  .base-content {
    display: flex;
    font-size: 15px;
    padding: 7px 0;
  }

  .base-content .base-info {
    display: flex;
    align-items: center;
    padding: 0 40px;
  }

  .base-content .base-info .base-title {
    word-break: keep-all;
  }

  .button-area {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    margin-top: 0;
  }

  /deep/.el-checkbox__label {
    display: block;
  }

  .checkbox-show {
    display: flex;
    margin-bottom: 10px;
  }
  .field-show {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 10px;
  }

  .product {
    display: flex;
    align-items: center;
  }

  .product-img {
    width: 60px;
    height: 40px;
    margin-right: 15px;
  }

  .product-text {
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-col-5 {
    width: 33%;
  }

  .ipt-sty {
    width: 69% !important;
  }
  .add-btn {
    width: 80%;
    height: 28px;
    line-height: 28px;
    margin-top: 8px;
    padding: 0;
  }
  .flex {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: space-between;
  }
  .flex1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .checkTag {
    background-color: rgb(242, 242, 242);
  }
  .btn {
    display: none;
  }
  .btn a {
    cursor: pointer;
  }
  .el-table__body tr:hover .btn {
    display: block;
  }

  /deep/.el-tree-node__label {
    width: 80%;
    white-space: normal;
    overflow: hidden;
    text-align: left;
  }

  .el-tree-node__content {
    height: auto;
  }

  .radio-ora {
    margin-right: 12px;
  }

  .staff-type {
    display: inline-block;
    width: 72px;
    height: 28px;
    line-height: 28px;
    color: #4fa1a4;
    background: rgba(234, 248, 248, 0.39);
    border-radius: 2px;
  }

  .staff-type-biz {
    display: inline-block;
    width: 52px;
    height: 28px;
    line-height: 28px;
    color: #4fa1a4;
    background: rgba(234, 248, 248, 0.39);
    border-radius: 2px;
  }

  .staff-wrap {
    color: #d8814b;
    background: rgba(255, 238, 224, 0.39);
  }

  .biz-state {
    display: inline-block;
    width: 48px;
    height: 21px;
    line-height: 21px;
    background: rgba(239, 239, 239, 0.38);
    border-radius: 11px;
    margin-left: 5px;
  }

  .select-node {
    margin: 0 0 17px 0;
    text-align: left;
    font-size: 18px;
    color: #323233;
  }

  .custom-tree-node {
    display: inline-flex;
    overflow: hidden;
  }

  .content-main-box {
    overflow-y: visible;
  }

  .search-area-div{
    flex-shrink: 0;
    margin-right: 4px
  }
  .ipt-sty{
    flex: 1;
  }
  .el-col-6{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-12{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-8{
    display: flex;
    // margin-bottom: 15px;
    justify-content: flex-end;
  }
  /* .el-pagination {
    width: calc(100% - 260px - 231px);
  } */
</style>

